import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import useHandleUserService from './hooks/useHandleUserService';
import useOpenIntercomService from './hooks/useOpenIntercomService';
import InactiveHeaderImage from './images/InactiveHeaderImage';
import InactiveUserStyles from './InactiveUser.style';

const InactiveUser = () => {
  const { t } = useTranslation();
  const { isUserInactive, name, lastName } = useHandleUserService();
  const { show } = useOpenIntercomService();

  if (!isUserInactive) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <div className={InactiveUserStyles.wrapper}>
      <InactiveHeaderImage />
      <Typography variant="h4" sx={{ typography: { sm: 'h4', xs: 'h5' } }}>
        {t('inactiveUserPageTitle')}
      </Typography>
      <Typography className={InactiveUserStyles.text} variant="body2">
        {t('inactiveUserMessage1')}{' '}
        <Typography
          variant="body2"
          component="span"
          className={InactiveUserStyles.boldText}
        >
          {name} {lastName}
        </Typography>{' '}
        {t('inactiveUserMessage2')}
      </Typography>
      <Typography className={InactiveUserStyles.text} variant="body2">
        {t('inactiveUserMessage3')}{' '}
        <a href="mailto:help@efexpay.com">help@efexpay.com</a>{' '}
        {t('inactiveUserMessage4')}
      </Typography>
      <Button
        variant="contained"
        className={InactiveUserStyles.actionButton}
        onClick={() => show()}
      >
        {t('contactUs')}
      </Button>
    </div>
  );
};

export default InactiveUser;
